<div class="d-flex">
    <div class="h3 m-2">Manager Log</div>

    <div class="d-flex ms-auto">

        <p-button pRipple styleClass="p-button-raised  m-2" (click)="newPost()">
            <ng-template pTemplate="content">
                <fa-icon [icon]='["far","plus"]' size="lg" class="ms-1"></fa-icon>
            </ng-template>
        </p-button>
    </div>
</div>

<p-card>
    <p-table *ngIf="!managerLogPostSelected" #dt styleClass="p-datatable-responsive-demo"
        [value]="managerLogPostFilteredList" dataKey="canvasKey"
        [paginator]="managerLogPostFilteredList && managerLogPostFilteredList.length > 10" [rows]="10" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="[10,25,50]" [globalFilterFields]="['subject','created','tags']">
        <ng-template pTemplate="caption">
            <div class="table-header d-flex">
                <div class="flex-grow-1">
                    <span class="p-float-label p-input-icon-left mt-2 mb-2 w-100 globalSearch">
                        <i class="pi pi-search "></i>
                        <input pInputText class="w-100" id="globalSearch" name="globalSearch" style="width: 100%" type="text"
                            (input)="dt.filterGlobal($event.target.value, 'contains')" />
                        <label for="globalSearch">Search by subject, tags...</label>
                    </span>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header" #header>
            <tr>
                <th pSortableColumn="created">
                    <div class="d-flex justify-content-between">
                        <div>
                            Date
                        </div>
                        <div>
                            <p-columnFilter type="date" field="created" display="menu"></p-columnFilter>
                            <p-sortIcon field="created"></p-sortIcon>
                        </div>
                    </div>
                </th>
                <th pSortableColumn="businessDate">
                    <div class="d-flex justify-content-between">
                        <div>
                            Business Date
                        </div>
                        <div>
                            <p-columnFilter type="date" field="businessDate" display="menu"></p-columnFilter>
                            <p-sortIcon field="businessDate"></p-sortIcon>
                        </div>
                    </div>
                    
                    
                </th>
                <th pSortableColumn="subject">
                    <div class="d-flex justify-content-between">
                        <div>
                            Subject
                        </div>
                        <div>
                            <p-sortIcon field="subject"></p-sortIcon>
                        </div>
                    </div>
                </th>
                <th>
                    Tags
                </th>
                <th pSortableColumn="authorUserKey">
                    <div class="d-flex justify-content-between">
                        <div>
                            Author
                        </div>
                        <div>
                            <p-sortIcon field="authorUserKey"></p-sortIcon>
                        </div>
                    </div>
                </th>
                <th>

                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" #body let-rec let-idx=index>
            <tr>
                <td>
                    <span class="p-column-title">Date</span>
                    {{moment(rec.created).format('l LT')}}
                </td>
                <td>
                    <span class="p-column-title">Business Date</span>
                    {{moment(rec.businessDate).format('l')}}
                </td>
                <td>
                    <span class="p-column-title">Subject</span>
                    {{rec.subject}}
                </td>
                <td>
                    <span class="p-column-title">Tags</span>
                    {{rec.tags}}
                </td>
                <td>
                    <span class="p-column-title">Author</span>
                    {{rec.authorUser.firstName}} {{rec.authorUser.lastName}}
                </td>
                <td style="text-align: right;">
                    <p-button *ngIf="user.role > 1" pRipple styleClass="p-button-raised p-button-danger m-2" (click)="deletePost(rec.pk, rec.sk)">
                        <ng-template pTemplate="content">
                            <fa-icon [icon]='["far","trash"]' size="lg" class="ms-1"></fa-icon>
                        </ng-template>
                    </p-button>
                    <p-button pRipple styleClass="p-button p-button-secondary m-2" (click)="managerLogPostSelected = rec" pTooltip="View Log">
                        <ng-template pTemplate="content">
                            <fa-icon [icon]='["far","eye"]' size="lg" class="ms-1"></fa-icon>
                        </ng-template>
                    </p-button>
                </td>

            </tr>
        </ng-template>
    </p-table>

    <p-card *ngIf="managerLogPostSelected">
        <app-log-viewer [managerLogPostSelected]="managerLogPostSelected" (clearEmitter)="managerLogPostSelected = undefined" (completedLogEmitter)="this.managerLogPostList.push($event)"></app-log-viewer>
    </p-card>
</p-card>